module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "darkblue-theme shadowed"
  }, [_c('bannerSlider', {
    class: {
      nobreadcrumbs: !_vm.hasBreadcrumbs
    },
    attrs: {
      "selectedLang": _vm.selectedLang
    }
  })], 1), _vm._v(" "), _c('section', {
    staticClass: "highlights"
  }, [_c('div', {
    staticClass: "cta"
  }, [_c('router-link', {
    staticClass: "green-theme-dark",
    attrs: {
      "to": "login"
    }
  }, [_vm._v(_vm._s(_vm.$t('buttons.login')))])], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4605fd02"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/home-euroregio/home-euroregio.vue
// module id = 303
// module chunks = 0